(function () {
  if (window.__IRONSIDE_UGC_CAROUSEL_V25__) return;
  window.__IRONSIDE_UGC_CAROUSEL_V25__ = true;

  var ROOT_SELECTOR = '[data-ironside-ugc-section]';
  var ACTIVE_CLASS = 'active';
  var MODAL_CLASS = 'ironside-ugc-modal-open';
  var MOBILE_QUERY = '(max-width: 989px)';
  var CLOSE_ANIMATION_MS = 240;
  var LOADER_DELAY_MS = 160;
  var LOADER_FALLBACK_MS = 4500;

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function sanitizeVideoId(id) {
    return String(id || '').replace(/[^a-zA-Z0-9_-]/g, '');
  }

  function createIframe(videoId, title) {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&playsinline=1&rel=0&modestbranding=1&controls=1';
    iframe.title = title || 'Video de YouTube';
    iframe.loading = 'eager';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; clipboard-write; web-share';
    iframe.allowFullscreen = true;
    return iframe;
  }

  function createLoaderMarkup() {
    return '<div class="ironside-ugc-loader" data-ironside-ugc-loader><span class="ironside-ugc-spinner"></span></div>';
  }

  function ensureSectionId(section, index) {
    if (!section.dataset.ugcSectionId) {
      section.dataset.ugcSectionId = 'ugc-' + index + '-' + Date.now();
    }
    return section.dataset.ugcSectionId;
  }

  function moveLightboxToBody(section, lightbox, index) {
    if (!section || !lightbox) return;

    var id = ensureSectionId(section, index);
    lightbox.dataset.ugcOwnerId = id;

    if (lightbox.parentNode !== document.body) {
      document.body.appendChild(lightbox);
    }
  }

  function lockPage(open) {
    document.documentElement.classList.toggle(MODAL_CLASS, open);
    document.body.classList.toggle(MODAL_CLASS, open);
  }

  function initSection(section, index) {
    if (!section || section.dataset.ugcReady === 'true') return;

    var track = qs(section, '[data-ironside-ugc-track]');
    var lightbox = qs(section, '[data-ironside-ugc-lightbox]');
    var openButtons = qsa(section, '[data-ironside-ugc-open]');
    var carouselPrev = qs(section, '[data-ironside-ugc-carousel-prev]');
    var carouselNext = qs(section, '[data-ironside-ugc-carousel-next]');

    if (!track || !lightbox || !openButtons.length) return;

    section.dataset.ugcReady = 'true';
    ensureSectionId(section, index);
    moveLightboxToBody(section, lightbox, index);

    var controller = window.AbortController ? new AbortController() : null;
    var signal = controller ? controller.signal : undefined;
    section.__ironsideUgcAbort = controller;

    var videoBox = qs(lightbox, '[data-ironside-ugc-lightbox-video]');
    var titleNode = qs(lightbox, '[data-ironside-ugc-lightbox-title]');
    var counterNode = qs(lightbox, '[data-ironside-ugc-counter]');
    var closeButtons = qsa(lightbox, '[data-ironside-ugc-close]');
    var nextButtons = qsa(lightbox, '[data-ironside-ugc-next]');
    var prevButtons = qsa(lightbox, '[data-ironside-ugc-prev]');
    var swipeArea = qs(lightbox, '[data-ironside-ugc-swipe-area]');

    var currentIndex = 0;
    var activeTrigger = null;
    var loaderTimer = null;
    var fallbackTimer = null;
    var trackStartX = 0;
    var trackStartY = 0;
    var hasDraggedTrack = false;
    var suppressClickUntil = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var resizeRaf = null;

    function addListener(target, type, handler, options) {
      if (!target) return;
      var opts = options || false;

      if (signal && typeof opts === 'object') {
        opts.signal = signal;
      } else if (signal) {
        opts = { signal: signal };
      }

      target.addEventListener(type, handler, opts);
    }

    function clearTimers() {
      if (loaderTimer) {
        clearTimeout(loaderTimer);
        loaderTimer = null;
      }

      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
    }

    function getLoader() {
      return qs(lightbox, '[data-ironside-ugc-loader]');
    }

    function showLoaderDelayed() {
      clearTimers();

      loaderTimer = setTimeout(function () {
        var loader = getLoader();
        if (loader) loader.classList.add(ACTIVE_CLASS);
      }, LOADER_DELAY_MS);

      fallbackTimer = setTimeout(function () {
        hideLoader();
      }, LOADER_FALLBACK_MS);
    }

    function hideLoader() {
      var loader = getLoader();
      if (loader) loader.classList.remove(ACTIVE_CLASS);
    }

    function resetVideoBox() {
      if (videoBox) videoBox.innerHTML = createLoaderMarkup();
    }

    function normalizeIndex(nextIndex) {
      if (nextIndex < 0) return openButtons.length - 1;
      if (nextIndex >= openButtons.length) return 0;
      return nextIndex;
    }

    function getCardGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    }

    function getScrollStep() {
      var card = qs(section, '[data-ironside-ugc-card]');
      if (!card) return Math.max(240, track.clientWidth * 0.75);
      return card.offsetWidth + getCardGap();
    }

    function updateCarouselButtons() {
      if (!track) return;

      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      var hasOverflow = maxScroll > 4;

      if (carouselPrev) carouselPrev.disabled = !hasOverflow || atStart;
      if (carouselNext) carouselNext.disabled = !hasOverflow || atEnd;
    }

    function scheduleCarouselUpdate() {
      if (resizeRaf) return;

      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = null;
        updateCarouselButtons();
      });
    }

    function centerCard(indexToCenter) {
      var btn = openButtons[indexToCenter];
      var card = btn ? btn.closest('[data-ironside-ugc-card]') : null;

      if (!card || !track) return;

      var targetLeft = card.offsetLeft - (track.clientWidth / 2) + (card.offsetWidth / 2);

      track.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function updateMeta() {
      var btn = openButtons[currentIndex];
      var title = btn ? btn.getAttribute('data-video-title') || '' : '';

      if (titleNode) titleNode.textContent = title;
      if (counterNode) counterNode.textContent = (currentIndex + 1) + ' / ' + openButtons.length;
    }

    function render(indexToRender) {
      var btn;
      var videoId;
      var title;
      var iframe;

      currentIndex = normalizeIndex(indexToRender);
      btn = openButtons[currentIndex];

      if (!btn || !videoBox) return;

      videoId = sanitizeVideoId(btn.getAttribute('data-video-id'));
      title = btn.getAttribute('data-video-title') || 'Video de YouTube';

      if (!videoId) return;

      resetVideoBox();
      showLoaderDelayed();

      iframe = createIframe(videoId, title);
      iframe.onload = function () {
        clearTimers();
        hideLoader();
      };

      videoBox.appendChild(iframe);

      updateMeta();
      centerCard(currentIndex);
    }

    function open(indexToOpen, trigger) {
      activeTrigger = trigger || document.activeElement;

      moveLightboxToBody(section, lightbox, index);
      lightbox.hidden = false;
      lockPage(true);
      render(indexToOpen);

      requestAnimationFrame(function () {
        lightbox.classList.add(ACTIVE_CLASS);

        var closeBtn = qs(lightbox, '[data-ironside-ugc-close]');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    }

    function close() {
      if (lightbox.hidden) return;

      lightbox.classList.remove(ACTIVE_CLASS);
      clearTimers();
      hideLoader();

      setTimeout(function () {
        lightbox.hidden = true;
        resetVideoBox();
        lockPage(false);

        if (activeTrigger && typeof activeTrigger.focus === 'function') {
          activeTrigger.focus({ preventScroll: true });
        }
      }, CLOSE_ANIMATION_MS);
    }

    function next() {
      render(currentIndex + 1);
    }

    function prev() {
      render(currentIndex - 1);
    }

    openButtons.forEach(function (button, buttonIndex) {
      addListener(button, 'click', function (event) {
        if (Date.now() < suppressClickUntil || hasDraggedTrack) {
          event.preventDefault();
          return;
        }

        open(buttonIndex, button);
      });
    });

    closeButtons.forEach(function (button) {
      addListener(button, 'click', close);
    });

    nextButtons.forEach(function (button) {
      addListener(button, 'click', next);
    });

    prevButtons.forEach(function (button) {
      addListener(button, 'click', prev);
    });

    addListener(carouselPrev, 'click', function () {
      track.scrollBy({
        left: getScrollStep() * -2,
        behavior: 'smooth'
      });
    });

    addListener(carouselNext, 'click', function () {
      track.scrollBy({
        left: getScrollStep() * 2,
        behavior: 'smooth'
      });
    });

    addListener(track, 'scroll', scheduleCarouselUpdate, { passive: true });
    addListener(window, 'resize', scheduleCarouselUpdate, { passive: true });
    updateCarouselButtons();

    addListener(track, 'pointerdown', function (event) {
      trackStartX = event.clientX;
      trackStartY = event.clientY;
      hasDraggedTrack = false;
    }, { passive: true });

    addListener(track, 'pointermove', function (event) {
      var dx = Math.abs(event.clientX - trackStartX);
      var dy = Math.abs(event.clientY - trackStartY);

      if (dx > 8 && dx > dy) {
        hasDraggedTrack = true;
        suppressClickUntil = Date.now() + 260;
      }
    }, { passive: true });

    addListener(track, 'pointerup', function () {
      setTimeout(function () {
        hasDraggedTrack = false;
      }, 70);
    }, { passive: true });

    addListener(document, 'keydown', function (event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next();
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') prev();
    });

    if (swipeArea) {
      addListener(swipeArea, 'touchstart', function (event) {
        if (lightbox.hidden || !event.touches || !event.touches.length) return;

        swipeStartX = event.touches[0].clientX;
        swipeStartY = event.touches[0].clientY;
      }, { passive: true });

      addListener(swipeArea, 'touchend', function (event) {
        if (lightbox.hidden || !event.changedTouches || !event.changedTouches.length) return;

        var endX = event.changedTouches[0].clientX;
        var endY = event.changedTouches[0].clientY;
        var dx = endX - swipeStartX;
        var dy = endY - swipeStartY;

        if (!isMobile()) return;
        if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy)) return;

        if (dx < 0) next();
        else prev();
      }, { passive: true });
    }

    resetVideoBox();
    updateMeta();
  }

  function initAll() {
    qsa(document, ROOT_SELECTOR).forEach(function (section, index) {
      initSection(section, index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    var sectionId;
    var movedLightbox;

    if (!section || !section.matches || !section.matches(ROOT_SELECTOR)) return;

    if (section.__ironsideUgcAbort) {
      section.__ironsideUgcAbort.abort();
      section.__ironsideUgcAbort = null;
    }

    sectionId = section.dataset ? section.dataset.ugcSectionId : '';
    movedLightbox = sectionId ? document.querySelector('[data-ugc-owner-id="' + sectionId + '"]') : null;

    if (movedLightbox) movedLightbox.remove();

    document.documentElement.classList.remove(MODAL_CLASS);
    document.body.classList.remove(MODAL_CLASS);
  });
})();
